import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { ListItemText, Tooltip, Typography } from '@material-ui/core';
import DropDownMenu from './DropDownMenu'
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import variables from '../../../Sys/variable.scss';

const useStyles = makeStyles((theme) => ({
    menuItemText: {
        color: "#fff",
        fontSize: '0.875rem',
        '&.MuiTypography-body1': {
            color: "#fff",
            fontSize: '0.875rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.8125rem',
            '&.MuiTypography-body1': {
                fontSize: '0.8125rem',
            },
        },
    },
    darkThemeColor: {
        color: variables.darkThemeText,
        fontSize: '0.875rem',
        '&.MuiTypography-body1': {
            color: variables.darkThemeText,
            fontSize: '0.875rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.8125rem',
            '&.MuiTypography-body1': {
                fontSize: '0.8125rem',
            },
        },
    },
}));

const isMenuItemSelected = (item, pathname) => {
    if (pathname.startsWith(item.active)) {
        return true;
    }
    return Array.isArray(item.alsoActive) && item.alsoActive.some((path) => pathname.startsWith(path));
};

const MenuItems = ({ menuItems, index, handleItemClick, location, collapsed = false, onRequestExpand = () => {} }) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const isSelected = isMenuItemSelected(menuItems, location.pathname);

    const handleClick = () => {
        setOpen(!open);
    };

    React.useEffect(() => {
        if (isSelected) {
            setOpen(true);
        }
    }, [location]);

    if (collapsed) {
        const handleCollapsedClick = () => {
            if (menuItems.submenus) {
                onRequestExpand();
            } else {
                handleItemClick(menuItems.active);
            }
        };

        return (
            <Tooltip title={menuItems.title} placement="right">
                <ListItem
                    data-testid={`sidebar-item-${menuItems.title.toLowerCase().replace(/\s+/g, '-')}`}
                    selected={isSelected}
                    style={{
                        marginBottom: 10,
                        justifyContent: 'center',
                        ...(isSelected && { backgroundColor: variables.sidebarActive }),
                    }}
                    onClick={handleCollapsedClick}
                    button
                    key={index}
                >
                    <ListItemIcon
                        style={{ minWidth: 0, justifyContent: 'center' }}
                        className={isSelected ? classes.menuItemText : classes.darkThemeColor}
                    >
                        {menuItems.icon}
                    </ListItemIcon>
                </ListItem>
            </Tooltip>
        );
    }

    return (
        <>
            {menuItems && menuItems.submenus ? (
                <>
                    <ListItem
                        data-testid={`sidebar-item-${menuItems.title.toLowerCase().replace(/\s+/g, '-')}`}
                        selected={isSelected}
                        style={{ marginBottom: 10, ...(isSelected && { backgroundColor: variables.sidebarActive }) }}
                        onClick={handleClick}
                        button
                        key={index}
                    >
                        <ListItemIcon className={isSelected ? classes.menuItemText : classes.darkThemeColor}>{menuItems.icon}</ListItemIcon>
                        <ListItemText primary={<Typography className={isSelected ? classes.menuItemText : classes.darkThemeColor}>{menuItems.title}</Typography>} />
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <DropDownMenu submenus={menuItems.submenus} handleItemClick={handleItemClick} location={location} />
                        </List>
                    </Collapse>
                </>
            ) : (
                <ListItem
                    data-testid={`sidebar-item-${menuItems.title.toLowerCase().replace(/\s+/g, '-')}`}
                    onClick={() => handleItemClick(menuItems.active)}
                    style={{ marginBottom: 10, ...(isSelected && { backgroundColor: variables.sidebarActive }) }}
                    selected={isSelected}
                    button
                    key={index}
                >
                    <ListItemIcon className={isSelected ? classes.menuItemText : classes.darkThemeColor}>{menuItems.icon}</ListItemIcon>
                    <ListItemText
                        primary={
                            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Typography className={isSelected ? classes.menuItemText : classes.darkThemeColor}>
                                    {menuItems.title}
                                </Typography>
                                {menuItems.badge ? (
                                    <span
                                        style={{
                                            backgroundColor: '#EC7A12',
                                            color: '#fff',
                                            fontSize: 10,
                                            fontWeight: 700,
                                            lineHeight: 1,
                                            padding: '3px 6px',
                                            borderRadius: 4,
                                            letterSpacing: 0.3,
                                        }}
                                    >
                                        {menuItems.badge}
                                    </span>
                                ) : null}
                            </span>
                        }
                    />
                </ListItem>
            )}
        </>
    );
}

export default MenuItems;